import React from 'react';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import './TabbedPanel.css'
import Input from '../../UI/Input/Input'
import Button from '../../UI/Button/Button'
import { checkValidity, updateObject } from '../../../shared/utility'
import { Redirect } from 'react-router-dom'
import AboutUs from '../../AboutUs/AboutUs'
import Faq from '../../Faq/Faq'

        function TabPanel(props) {
            const {children, value, index, ...other} = props;
            return (
                    <div
                        role="tabpanel"
                        hidden={value !== index}
                        id={`full-width-tabpanel-${index}`}
                        aria-labelledby={`full-width-tab-${index}`}
                        {...other}
                        >
                        {value === index && (
                                                    <Box p={1}>
                                                        <Typography>{children}</Typography>
                                                    </Box>
                                            )}
                    </div>
                    );
        }

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};
function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
        root: {
            backgroundColor: theme.palette.background.paper,
            width: 1650,
        },
        tabPanel: {
            overflow: "hidden !important",
            fontFamily: 'iranyekan !important',
            color: "rgba(0, 0, 0, 0.54)"
        }
    }));
const FullWidthTabs = (props) => {
    const classes = useStyles();
    const theme = useTheme();
    const [value, setValue] = React.useState(0);
    const tabs = props.tabs

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const handleChangeIndex = (index) => {
        setValue(index);
    }

    return (
            <div className="row justify-content-center mt-5">
                <div className={[classes.root, "tabbed-root"].join(' ')}>
                    <AppBar position="static" color="default">
                        <Tabs
                            value={value}
                            onChange={handleChange}
                            indicatorColor="primary"
                            textColor="primary"
                            variant="fullWidth"
                            aria-label="full width tabs example"
                            >
                            {tabs.map(t => {
                                    return (
                                <Tab label={t.label} {...a11yProps(t.index)} />
                                            )
                                })
                            }
                        </Tabs>
                    </AppBar>
                    <SwipeableViews
                        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                        index={value}
                        onChangeIndex={handleChangeIndex}
                        >
            
                        {tabs.map(t => {
                                return (
                                <TabPanel className={classes.tabPanel} value={value} index={t.index} dir={theme.direction}>
                                    {t.value}
                                </TabPanel>
                                        )
                            })
                        }
                    </SwipeableViews>
                </div>
            </div>
            );
}
export default FullWidthTabs